import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
// import { connect } from "react-redux";
import i18n from "../../i18next";
import { changeLanguage } from "../../redux/actions/changeLanguageAction";
// import ChangeLanguage from "../ChangeLanguage/ChangeLanguage";

function CL() {
  const [isOpen, setIsOpen] = useState(false);
  const changeLanguageState = useSelector((state) => state.changeLanguage);
  const dispatch = useDispatch();

  useEffect(() => {
    i18n.changeLanguage(changeLanguageState.selectedLanguage);
  }, [changeLanguageState.selectedLanguage]);

  const handleLanguageChange = (lang) => dispatch(changeLanguage(lang));

  const changeLanguageDropdown = changeLanguageState.languages.map((l) => (
    <div key={l.locale} onClick={() => handleLanguageChange(l.locale)}>
      <DropdownItem>{l.name}</DropdownItem>
    </div>
  ));
  return (
    <span className="LanguagePicker_LanguagePickerControl__2tmDr chn-lng">
      {/* <span className="isvg loaded LanguagePicker_LanguagePickerControlIcon__yq2_X mr-2 globe">
        <svg
          version="1.1"
          id="Layer_1___YdYO7IHG"
          x="0px"
          y="0px"
          viewBox="0 0 511.999 511.999"
          style={{ enableBackground: "new 0 0 511.999 511.999", width: "20px" }}
        >
          <g>
            <g>
              <path
                d="M436.921,75.079C389.413,27.571,326.51,1.066,259.464,0.18C258.296,0.074,257.137,0,255.999,0s-2.297,0.074-3.465,0.18
			C185.488,1.065,122.585,27.57,75.077,75.078C26.752,123.405,0.138,187.657,0.138,255.999s26.614,132.595,74.94,180.921
			c47.508,47.508,110.41,74.013,177.457,74.898c1.168,0.107,2.327,0.18,3.464,0.18c1.138,0,2.297-0.074,3.465-0.18
			c67.047-0.885,129.95-27.39,177.457-74.898c48.325-48.325,74.939-112.577,74.939-180.921
			C511.861,187.657,485.247,123.405,436.921,75.079z M96.586,96.587c27.181-27.181,60.086-46.552,95.992-57.018
			c-8.093,9.317-15.96,20.033-23.282,31.908c-9.339,15.146-17.425,31.562-24.196,48.919H75.865
			C82.165,112.063,89.071,104.102,96.586,96.587z M56.486,150.813h78.373c-8.15,28.522-12.97,58.908-14.161,89.978H31.071
			C33.176,208.987,41.865,178.465,56.486,150.813z M56.487,361.186c-14.623-27.652-23.312-58.174-25.417-89.978h89.627
			c1.191,31.071,6.011,61.457,14.161,89.978H56.487z M96.587,415.412c-7.517-7.515-14.423-15.475-20.722-23.809h69.236
			c6.771,17.357,14.856,33.773,24.196,48.919c7.322,11.875,15.189,22.591,23.282,31.908
			C156.674,461.964,123.769,442.593,96.587,415.412z M240.79,475.322c-12.671-8.29-29.685-24.946-45.605-50.764
			c-6.385-10.354-12.124-21.382-17.197-32.954h62.801V475.322z M240.79,361.186h-74.195c-8.888-28.182-14.163-58.651-15.459-89.978
			h89.654V361.186z M240.79,240.791h-89.654c1.295-31.327,6.57-61.797,15.459-89.978h74.195V240.791z M240.79,120.395h-62.801
			c5.073-11.572,10.812-22.6,17.197-32.954c15.919-25.818,32.934-42.475,45.605-50.764V120.395z M455.512,150.813
			c14.623,27.653,23.311,58.174,25.416,89.978H391.3c-1.191-31.071-6.011-61.457-14.161-89.978H455.512z M415.413,96.587
			c7.515,7.515,14.421,15.476,20.721,23.809h-69.235c-6.771-17.357-14.856-33.773-24.196-48.919
			c-7.322-11.875-15.188-22.591-23.282-31.908C355.326,50.035,388.231,69.406,415.413,96.587z M271.208,36.677
			c12.671,8.29,29.685,24.946,45.605,50.764c6.385,10.354,12.124,21.382,17.197,32.954h-62.801V36.677z M271.208,150.813h74.195
			c8.889,28.182,14.164,58.653,15.459,89.978h-89.654V150.813z M360.861,271.208c-1.295,31.327-6.57,61.797-15.459,89.978h-74.195
			v-89.978H360.861z M271.208,475.322v-83.718h62.801c-5.073,11.572-10.812,22.6-17.197,32.954
			C300.893,450.377,283.879,467.032,271.208,475.322z M415.413,415.413c-27.182,27.181-60.086,46.551-95.992,57.018
			c8.093-9.317,15.96-20.033,23.282-31.908c9.339-15.146,17.425-31.562,24.196-48.919h69.235
			C429.835,399.937,422.928,407.898,415.413,415.413z M455.512,361.186h-78.373c8.15-28.521,12.971-58.907,14.161-89.978h89.627
			C478.822,303.012,470.133,333.534,455.512,361.186z"
              ></path>
            </g>
          </g>
        </svg>
      </span> */}
      <span className="LanguagePicker_languageCode__3MRL1 dropdown">
        {" "}
        <span>
          <span className="change-language ml-auto">
            <span className="copyright">
              <Dropdown
                direction="right"
                isOpen={isOpen}
                toggle={() => setIsOpen((state) => !state)}
                size="sm"
                style={{ display: "inline" }}
              >
                <DropdownToggle caret>
                  {changeLanguageState.selectedLanguage}
                </DropdownToggle>
                <DropdownMenu className="lang-dropdown">
                  {changeLanguageDropdown}
                </DropdownMenu>
              </Dropdown>
            </span>
          </span>
        </span>
      </span>
    </span>
  );
}

export default CL;
